import { render } from "./medical-records.vue?vue&type=template&id=429301b0"
import script from "./medical-records.vue?vue&type=script&lang=js"
export * from "./medical-records.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__